import { render, staticRenderFns } from "./ListPaciente.vue?vue&type=template&id=308362a9&scoped=true&"
import script from "./ListPaciente.vue?vue&type=script&lang=js&"
export * from "./ListPaciente.vue?vue&type=script&lang=js&"
import style0 from "./ListPaciente.vue?vue&type=style&index=0&id=308362a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308362a9",
  null
  
)

export default component.exports